export const loginPayload = {
    grant_type: 'password'
}

export const refreshPayload = {
    grant_type: 'refresh_token'
}

export const mfaPayload = {
    grant_type: 'mfa'
}

export const loginOptions = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Authorization: 'Basic ZWFzeW1zOnNlY3JldA=='
    }
}


// WEBPACK FOOTER //
// ./src/config/authConfig.js